<template>
  <div class="tenant-list-container">
    <!-- 搜索区域 -->
    <el-card class="search-card" shadow="never">
      <el-form :model="queryParams" :inline="true" class="search-form">
        <el-form-item label="公司名称：">
          <el-input
            v-model="queryParams.search_name"
            placeholder="请输入公司名称"
            clearable
            style="width: 200px"
            @keyup.enter.native="handleSearch"
          />
        </el-form-item>
        
        <el-form-item>
          <el-button type="primary" icon="el-icon-search" @click="handleSearch">
            搜索
          </el-button>
          <el-button icon="el-icon-refresh" @click="handleReset">
            重置
          </el-button>
          <el-button 
            type="success" 
            icon="el-icon-plus" 
            @click="handleAdd"
            class="btn-add"
          >
            添加租户
          </el-button>
        </el-form-item>
      </el-form>
    </el-card>

    <!-- 数据表格 -->
    <el-card class="table-card" shadow="never">
      <div class="table-header">
        <div class="table-title">
          <i class="el-icon-office-building"></i>
          租户列表
        </div>
        <div class="table-actions">
          <el-input
            v-model="quickSearch"
            placeholder="快速搜索..."
            prefix-icon="el-icon-search"
            style="width: 200px; margin-right: 10px;"
            size="small"
            clearable
            @input="handleQuickSearch"
          />
        </div>
      </div>
      
      <el-table
        ref="tenantTable"
        v-loading="loading"
        :data="tableData"
        border
        stripe
        style="width: 100%"
        :height="tableHeight"
        @selection-change="handleSelectionChange"
        >
        <!-- 序号列 -->
        <el-table-column 
          label="序号" 
          width="80"
          align="center"
        >
          <template slot-scope="scope">
            <span class="serial-number">
              {{ (pageIndex - 1) * pageSize + scope.$index + 1 }}
            </span>
          </template>
        </el-table-column>
        
        <!-- 公司名称 -->
        <el-table-column 
          prop="tenantname" 
          label="公司名称" 
          width="400"
          show-overflow-tooltip
        >
          <template slot-scope="{ row }">
            <div class="company-cell">
              <i class="el-icon-office-building" style="margin-right: 5px; color: #409EFF;"></i>
              <span>{{ row.tenantname || '-' }}</span>
            </div>
          </template>
        </el-table-column>
        
        <!-- 联系人 -->
        <el-table-column 
          prop="contact" 
          label="联系人" 
          width="350"
          align="center"
        >
          <template slot-scope="{ row }">
            <div class="contact-cell">
              <i class="el-icon-user" style="margin-right: 5px; color: #67c23a;"></i>
              <span>{{ row.contact || '-' }}</span>
            </div>
          </template>
        </el-table-column>
        
        <!-- 联系电话 -->
        <el-table-column 
          prop="contactphone" 
          label="联系电话" 
          width="350"
          align="center"
        >
          <template slot-scope="{ row }">
            <div class="phone-cell">
              <i class="el-icon-phone" style="margin-right: 5px; color: #f56c6c;"></i>
              <span>{{ row.contactphone || '-' }}</span>
            </div>
          </template>
        </el-table-column>
        
        <!-- 操作列 -->
        <el-table-column 
          label="操作" 
          width="250" 
          align="center"
          fixed="right"
        >
          <template slot-scope="{ row }">
            <div class="action-buttons">
              <el-tooltip content="编辑" placement="top">
                <el-button
                  type="warning"
                  size="mini"
                  icon="el-icon-edit"
                  @click="handleEdit(row)"
                >
                  编辑
                </el-button>
              </el-tooltip>
              
              <el-tooltip content="删除" placement="top">
                <el-button
                  type="danger"
                  size="mini"
                  icon="el-icon-delete"
                  @click="handleDelete(row)"
                >
                  删除
                </el-button>
              </el-tooltip>
            </div>
          </template>
        </el-table-column>
      </el-table>

      <!-- 分页 -->
      <div class="footer-area">
        <el-pagination
          v-if="total > 0"
          class="pagination-container"
          :current-page.sync="pageIndex"
          :page-sizes="[ 10, 15, 20,50]"
          :page-size="pageSize"
          layout="total, sizes, prev, pager, next, jumper"
          :total="total"
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
        />
      </div>
      
      <!-- 空状态 -->
      <div v-if="!loading && tableData.length === 0" class="empty-state">
        <i class="el-icon-office-building" style="font-size: 60px; color: #c0c4cc;"></i>
        <p style="color: #c0c4cc; margin-top: 10px;">暂无租户数据</p>
        <el-button 
          type="primary" 
          size="small" 
          icon="el-icon-plus" 
          @click="handleAdd"
          style="margin-top: 10px;"
        >
          添加租户
        </el-button>
      </div>
    </el-card>

    <!-- 新增租户对话框 -->
    <TenantAddDialog
      :visible="addDialogVisible"
      @close="handleAddDialogClose"
      @save="handleAddSave"
    />
    
    <!-- 编辑租户对话框 -->
    <TenantEditDialog
      :visible="editDialogVisible"
      :form-data="currentFormData"
      @close="handleEditDialogClose"
      @save="handleEditSave"
    />
  </div>
</template>

<script>
import tenantApi from '../api/tenant.js'
import TenantAddDialog from '../components/TenantAddDialog'
import TenantEditDialog from '../components/TenantEditDialog'

export default {
  name: "TenantList",
  components: {
    TenantAddDialog,
    TenantEditDialog
  },
  
  data() {
    return {
      // 加载状态
      loading: false,
      
      // 原始数据（保持不变）
      originalData: [],
      // 当前显示的数据
      tableData: [],
      // 筛选后的数据
      filteredData: [],
      total: 0,
      
      // 快速搜索
      quickSearch: '',
      
      // 分页参数
      pageIndex: 1,
      pageSize: 10,
      
      // 查询参数
      queryParams: {
        search_name: ''
      },
      
      // 对话框相关
      addDialogVisible: false,
      editDialogVisible: false,
      currentFormData: {},
      
      // 表格高度
      tableHeight: 500,
      
      // 搜索防抖
      searchTimer: null,
      
      // 防抖函数引用
      debouncedResize: null,
      
      // 选择的租户
      selectedTenants: []
    }
  },
  
  created() {
    console.log('TenantList created');
    this.getProfile();
  },
  
  mounted() {
    console.log('TenantList mounted');
    this.initTableHeight();
    
    // 使用防抖的resize监听
    var self = this;
    this.debouncedResize = this.debounce(function() {
      self.initTableHeight();
    }, 150);
    
    window.addEventListener('resize', this.debouncedResize);
  },
  
  activated() {
    console.log('TenantList activated - 组件被激活');
    // 如果数据为空，重新加载
    if (this.originalData.length === 0) {
      this.getProfile();
    }
    
    // 重新计算表格高度
    this.$nextTick(function() {
      this.initTableHeight();
    });
  },
  
  beforeDestroy() {
    console.log('TenantList beforeDestroy');
    this.cleanup();
  },
  
  methods: {
    /**
     * 清理资源
     */
    cleanup() {
      console.log('清理资源');
      
      // 清除事件监听
      if (this.debouncedResize) {
        window.removeEventListener('resize', this.debouncedResize);
        this.debouncedResize = null;
      }
      
      // 清除定时器
      if (this.searchTimer) {
        clearTimeout(this.searchTimer);
        this.searchTimer = null;
      }
      
      // 清空数据引用（避免内存泄漏）
      this.tableData = [];
      this.originalData = [];
      this.filteredData = [];
      this.total = 0;
      this.selectedTenants = [];
      
      // 清空对话框数据
      this.currentFormData = null;
      
      // 重置查询参数
      this.queryParams = {
        search_name: ''
      };
      this.quickSearch = '';
      
      // 重置分页
      this.pageIndex = 1;
      this.pageSize = 5;
    },
    
    /**
     * 防抖函数
     */
    debounce(func, wait) {
      var timeout;
      return function executedFunction() {
        var context = this;
        var args = arguments;
        var later = function() {
          clearTimeout(timeout);
          func.apply(context, args);
        };
        clearTimeout(timeout);
        timeout = setTimeout(later, wait);
      };
    },
    
    /**
     * 初始化表格高度
     */
    initTableHeight() {
      // 使用固定高度或根据窗口计算
      var windowHeight = window.innerHeight;
      var containerTop = 300;
      
      // 安全地获取元素位置
      if (this.$el && this.$el.getBoundingClientRect) {
        var rect = this.$el.getBoundingClientRect();
        if (rect && rect.top) {
          containerTop = rect.top;
        }
      }
      
      this.tableHeight = Math.max(400, windowHeight - containerTop - 100);
    },
    
    /**
     * 获取租户列表
     */
    getProfile() {
      if (this.loading) {
        console.log('已经在加载中，跳过重复请求');
        return;
      }
      
      var self = this;
      this.loading = true;
      console.log('开始加载租户数据');
      
      // 设置超时保护
      var timeoutTimer = setTimeout(function() {
        if (self.loading) {
          console.warn('租户数据加载超时，强制结束');
          self.loading = false;
          self.$message.error('数据加载超时，请刷新页面重试');
        }
      }, 10000); // 10秒超时
      
      tenantApi.getAllTenantList().then(function(response) {
        clearTimeout(timeoutTimer);
        
        if (response && response.data && response.data.flag === true) {
          self.originalData = response.data.data || [];
          self.filteredData = response.data.data || [];
          self.total = self.originalData.length;
          
          // 应用当前筛选和分页
          self.applyFilter();
          
          console.log('已加载 ' + self.originalData.length + ' 条租户数据');
          
          if (self.originalData.length === 0) {
            self.$message.info('暂无租户数据');
          } else {
            self.$message.success('已加载 ' + self.originalData.length + ' 条租户数据');
          }
        } else {
          console.error('获取租户列表失败:', response);
          self.$message.error('获取租户列表失败');
          self.originalData = [];
          self.filteredData = [];
          self.total = 0;
          self.tableData = [];
        }
      }).catch(function(error) {
        clearTimeout(timeoutTimer);
        
        console.error('获取租户列表失败:', error);
        self.$message.error('加载失败，请检查网络连接');
        self.originalData = [];
        self.filteredData = [];
        self.total = 0;
        self.tableData = [];
      }).finally(function() {
        self.loading = false;
      });
    },
    
    /**
     * 应用分页
     */
    applyPagination() {
      var start = (this.pageIndex - 1) * this.pageSize;
      var end = start + this.pageSize;
      this.tableData = this.filteredData.slice(start, end);
    },
    
    /**
     * 应用筛选（基于原始数据筛选）
     */
    applyFilter() {
      var filtered = this.originalData.slice(); // 从原始数据开始筛选
      
      // 应用查询条件
      if (this.queryParams.search_name && this.queryParams.search_name.trim()) {
        var nameFilter = this.queryParams.search_name.trim();
        filtered = filtered.filter(function(item) {
          return item.tenantname && item.tenantname.includes(nameFilter);
        });
      }
      
      // 快速搜索
      if (this.quickSearch && this.quickSearch.trim()) {
        var search = this.quickSearch.trim().toLowerCase();
        filtered = filtered.filter(function(item) {
          return (
            (item.tenantname && item.tenantname.toLowerCase().includes(search)) ||
            (item.contact && item.contact.toLowerCase().includes(search)) ||
            (item.contactphone && item.contactphone.toLowerCase().includes(search))
          );
        });
      }
      
      // 更新筛选后的数据和总数
      this.filteredData = filtered;
      this.total = filtered.length;
      this.pageIndex = 1; // 重置到第一页
      this.applyPagination();
    },
    
    /**
     * 处理搜索
     */
    handleSearch() {
      this.applyFilter();
      if (this.filteredData.length === 0) {
        this.$message.info('未找到符合条件的租户');
      } else {
        this.$message.success('找到 ' + this.filteredData.length + ' 条符合条件的租户');
      }
    },
    
    /**
     * 处理快速搜索（防抖）
     */
    handleQuickSearch() {
      var self = this;
      if (this.searchTimer) {
        clearTimeout(this.searchTimer);
      }
      this.searchTimer = setTimeout(function() {
        self.applyFilter();
      }, 300);
    },
    
    /**
     * 处理重置
     */
    handleReset() {
      this.queryParams = {
        search_name: ''
      };
      this.quickSearch = '';
      this.pageIndex = 1;
      this.applyFilter(); // 直接应用筛选
    },
    
    /**
     * 处理选择变化
     */
    handleSelectionChange(selection) {
      this.selectedTenants = selection;
    },
    
    /**
     * 处理添加
     */
    handleAdd() {
      this.addDialogVisible = true;
    },
    
    /**
     * 处理编辑
     */
    handleEdit(row) {
      this.currentFormData = {
        tenantid: row.tenantid,
        tenantname: row.tenantname,
        contact: row.contact,
        contactphone: row.contactphone
      };
      
      this.editDialogVisible = true;
    },
    
    /**
     * 处理删除
     */
    handleDelete(row) {
      var tenantName = row.tenantname || '该租户';
      
      var self = this;
      this.$confirm('确定要删除租户 "' + tenantName + '" 吗？', '提示', {
        type: 'warning',
        confirmButtonText: '确定',
        cancelButtonText: '取消'
      }).then(function() {
        return tenantApi.deleteTenant(row.tenantid);
      }).then(function(response) {
        if (response.data && response.data.flag === true) {
          self.$message.success('租户 "' + tenantName + '" 删除成功');
          // 重新加载数据
          self.getProfile();
        } else {
          self.$message.error('删除失败');
        }
      }).catch(function(error) {
        if (error && error !== 'cancel') {
          console.error('删除失败:', error);
          self.$message.error('删除失败，请重试');
        }
      });
    },
    
    /**
     * 处理分页大小变化
     */
    handleSizeChange(size) {
      this.pageSize = size;
      this.pageIndex = 1;
      this.applyPagination();
    },
    
    /**
     * 处理页码变化
     */
    handleCurrentChange(page) {
      this.pageIndex = page;
      this.applyPagination();
    },
    
    /**
     * 处理添加对话框关闭
     */
    handleAddDialogClose() {
      this.addDialogVisible = false;
    },
    
    /**
     * 处理编辑对话框关闭
     */
    handleEditDialogClose() {
      this.editDialogVisible = false;
      this.currentFormData = {};
    },
    
    /**
     * 处理添加保存
     */
    handleAddSave(formData) {
      var self = this;
      tenantApi.addTenant(formData).then(function(response) {
        if (response && response.data && response.data.flag === true) {
          self.$message.success('新增成功');
          self.addDialogVisible = false;
          // 重新加载数据
          self.getProfile();
        } else {
          var message = (response && response.data && response.data.message) || '新增失败';
          self.$message.error(message);
        }
      }).catch(function(error) {
        console.error('新增失败:', error);
        self.$message.error('新增失败，请重试');
      });
    },
    
    /**
     * 处理编辑保存
     */
    handleEditSave(formData) {
      var self = this;
      tenantApi.updateTenant(formData).then(function(response) {
        if (response && response.data && response.data.flag === true) {
          self.$message.success('更新成功');
          self.editDialogVisible = false;
          self.currentFormData = {};
          // 重新加载数据
          self.getProfile();
        } else {
          var message = (response && response.data && response.data.message) || '更新失败';
          self.$message.error(message);
        }
      }).catch(function(error) {
        console.error('更新失败:', error);
        self.$message.error('更新失败，请重试');
      });
    }
  }
}
</script>

<style scoped>
.tenant-list-container {
  padding: 20px;
  background-color: #f5f7fa;
  min-height: calc(90vh - 84px);
}

.search-card {
  margin-bottom: 20px;
  border-radius: 8px;
  border: none;
}

.search-form {
  margin-bottom: -10px;
}

.btn-add {
  background-color: #67c23a;
  border-color: #67c23a;
  color: white;
}

.btn-add:hover {
  background-color: #5daf34;
  border-color: #5daf34;
  color: white;
}

.table-card {
  border-radius: 8px;
  overflow: hidden;
  border: none;
  position: relative;
}

.table-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 16px;
  padding: 0 8px;
}

.table-title {
  font-size: 18px;
  font-weight: 600;
  color: #303133;
  display: flex;
  align-items: center;
}

.table-title i {
  margin-right: 8px;
  color: #409EFF;
  font-size: 20px;
}

.table-actions {
  display: flex;
  align-items: center;
  gap: 10px;
}

.footer-area {
  display: flex;
  justify-content: flex-end;
  align-items: center;
  margin-top: 20px;
  padding-top: 20px;
  border-top: 1px solid #ebeef5;
}

.pagination-container {
  text-align: right;
}

.action-buttons {
  display: flex;
  justify-content: center;
  gap: 8px;
}

.empty-state {
  text-align: center;
  padding: 60px 0;
  background: white;
}

.company-cell {
  display: flex;
  align-items: center;
  color: #409EFF;
  font-weight: 500;
}

.contact-cell {
  display: flex;
  align-items: center;
  justify-content: center;
  color: #67c23a;
}

.phone-cell {
  display: flex;
  align-items: center;
  justify-content: center;
  color: #f56c6c;
}

.serial-number {
  color: #909399;
  font-weight: 500;
}

/* 简化样式，移除不必要的复杂样式 */
.el-table {
  font-size: 14px;
}

.el-table th {
  background-color: #f5f7fa !important;
  font-weight: 600;
}

.el-table td {
  padding: 12px 0;
}

.el-tag {
  min-width: 70px;
}
</style>

<style>
/* 移除全局复杂样式，使用默认样式 */
.tenant-list-container .el-table--border {
  border: 1px solid #ebeef5;
}

.tenant-list-container .el-table--enable-row-hover .el-table__body tr:hover > td {
  background-color: #f5f7fa;
}

.tenant-list-container .el-table__header th {
  background-color: #f5f7fa !important;
}

/* 移除响应式样式，使用默认响应式 */
/* 对话框样式简化 */
.tenant-list-container .el-dialog__body {
  max-height: 70vh;
  overflow-y: auto;
}

/* 分页器样式简化 */
.tenant-list-container .el-pagination {
  padding: 10px 0;
}

/* 优化表格性能 */
.tenant-list-container .el-table__body-wrapper {
  overflow-x: hidden !important;
}
</style>